import { render } from "./LangPicker.vue?vue&type=template&id=32e2bc35&scoped=true"
import script from "./LangPicker.vue?vue&type=script&lang=js"
export * from "./LangPicker.vue?vue&type=script&lang=js"

import "./LangPicker.vue?vue&type=style&index=0&id=32e2bc35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e2bc35"]])

export default __exports__